import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-fav-component-dailog',
  standalone: true,
  imports: [MatDialogModule,CommonModule],
  templateUrl: './fav-component-dailog.component.html',
  styleUrl: './fav-component-dailog.component.scss'
})
export class FavComponentDailogComponent {

  message: string = ""
  actionType: string="add"
  cancelButtonText = "Cancel"
  promptname: string = "";
  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogRef: MatDialogRef<FavComponentDailogComponent>) {
    if (data) {
      
      this.message = data.message || this.message;
      this.actionType = data.action_type
      this.promptname = data.favpromtname
    }
    this.dialogRef.updateSize('300vw','300vw')
  }

  onConfirmClick(): void {
    this.dialogRef.close(true);
  }

}
